// @mui
import { useDispatch } from 'react-redux';
import AppDialog from './AppDialog';
// utils

// ----------------------------------------------------------------------

export default function DeleteModal(props) {
    return (
        <>
            <AppDialog
                open={props.open}
                close={() => props.close()}
                title={`Delete ${props?.module || ''}`}
                titleIcon={'error'}
                positiveTitle={`Delete`}
                positivePress={() => props.submit()}
                positiveButtonStyle={{ backgroundColor: '#ED1A3D', color: 'white', border: '1px solid #ED1A3D' }}
                negativePress={() => props.close()}
                negativeTitle={'Cancel'}
                width={'30%'}
            >
                <div className="">
                    Are you sure you want to delete this {props?.module || ''}?
                </div>
            </AppDialog>
        </>


    );
}
